import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DiamondOutlinedIcon from "@mui/icons-material/DiamondOutlined";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { useNavigate } from "react-router-dom";
import { Volunteer } from "store/volunteers/volunteers.types";
import {
  NotificationCircle,
  ProfileVolunteerContainer,
  ProfileVolunteerDetail,
  ProfileVolunteerImage,
  ProfileVolunteerInfo,
  ProfileVolunteerName,
  ProfileVolunteerSpotlightIcons,
} from "../VolunteerSpotlight/Volunteer.styles";

const VolunteerCard: React.FC<Volunteer> = ({
  id,
  name,
  socialAvatarUrl,
  participation_count,
  bio_description,
}) => {
  const navigate = useNavigate();

  const handleProfileClick = () => {
    navigate(`/profile/${id}`);
  };

  return (
    <ProfileVolunteerContainer>
      <ProfileVolunteerImage
        src={socialAvatarUrl}
        alt={name}
        onClick={handleProfileClick}
        style={{ cursor: 'pointer' }}
      />
      <NotificationCircle>{participation_count}</NotificationCircle>
      <ProfileVolunteerInfo>
        <ProfileVolunteerName
          onClick={handleProfileClick}
          style={{ cursor: 'pointer' }}
        >
          {name}
        </ProfileVolunteerName>
        <ProfileVolunteerDetail>
          {bio_description}
        </ProfileVolunteerDetail>
      </ProfileVolunteerInfo>
      <ProfileVolunteerSpotlightIcons>
        <DiamondOutlinedIcon />
        <AddCircleOutlineIcon />
        <FavoriteBorderIcon />
      </ProfileVolunteerSpotlightIcons>
    </ProfileVolunteerContainer>
  );
};

export default VolunteerCard; 